import React from 'react';
import { SiOpenai } from "react-icons/si";
import { FaSnapchatGhost } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import { FaCcStripe } from "react-icons/fa";

const Partners = () => {

    const partners = [
        {
            logo: <SiOpenai className='text-white text-4xl md:text-5xl ' />,
            name: "OpenAI"
        },
        {
            logo: <FcGoogle className='text-4xl md:text-5xl' />,
            name: "Google"
        },
        {
            logo: <FaSnapchatGhost className='bg-[#FFFC00] text-white p-2 rounded-md text-4xl md:text-5xl' />,
            name: "Snapchat"
        },
        {
            logo: <FaCcStripe className='text-[#5433ff] text-4xl md:text-5xl' />,
            name: "Stripe"
        },
    ]

  return (
    <section className='my-10'>
        <div  className='p-3'>
         <div className='my-6 '>
             <h1 className='text-xl md:text-5xl font-bold text-white text-center'>
             Our partners:
             </h1>
         </div>

         <div className='flex justify-center items-center'>
         <div className='flex flex-wrap'>
           {partners.map((partner,idx)=>(
             <div key={idx} className='w-2/4 my-7 md:my-10 text-white flex justify-center items-center'>
                <div>
                    {partner.logo}
                </div>
                <p className='mx-4 text-xl md:text-3xl'>{partner.name}</p>
            </div>
           ))}
         </div>
         </div>  
         
          
        </div>
     </section>
    
  );
};

export default Partners;